<script setup lang="ts">
import { computed } from "vue";
import { formatFileSize } from "@/components/MyStudents/Submissions/utils";
import FileOutlineIcon from "@/components/shared/icons/FileOutlineIcon.vue";
import CloseIcon from "@/components/svg-icons/CloseIcon.vue";
import type { AttachmentChipProps } from "../types";

const props = withDefaults(defineProps<AttachmentChipProps>(), {
  size: undefined,
  removable: false,
});

const emit = defineEmits<(e: "remove") => void>();

const formattedSize = computed<string>(() => formatFileSize(props.size));
</script>

<template>
  <span
    class="inline-flex items-center gap-2 min-w-0 max-w-[260px] px-2.5 py-1.5 rounded-md border border-gray-175 bg-white text-12.5p font-semibold text-indigo-base"
    data-testid="internal-comment-attachment-chip"
  >
    <FileOutlineIcon class="w-3.5 h-3.5 shrink-0 -translate-y-px text-teal-900" />
    <span class="truncate" :title="name" data-testid="internal-comment-attachment-name">{{ name }}</span>
    <span
      v-if="!removable && formattedSize"
      class="shrink-0 font-medium text-gray-500"
      data-testid="internal-comment-attachment-size"
    >
      {{ formattedSize }}
    </span>
    <button
      v-if="removable"
      type="button"
      aria-label="Remove"
      class="inline-flex items-center justify-center shrink-0 w-[18px] h-[18px] rounded text-gray-500 hover:bg-gray-10 hover:text-error-900"
      data-testid="internal-comment-attachment-remove"
      @click="emit('remove')"
    >
      <CloseIcon size="12" stroke-width="2.4" />
    </button>
  </span>
</template>
